import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { AppState } from '@app/reducers';
import { countryCodes, CrudService, debounceTimeForSearchkeyword, destructureAfrigisObjectAddressComponents, disableFormControls, enableFormControls, formConfigs, getFullFormatedAddress, IApplicationResponse, LoggedInUserModel, mapConfigurationUtils, ModulesBasedApiSuffix, prepareRequiredHttpParams, removeFormControlError, ResponseMessageTypes, RxjsService, setRequiredValidator, SnackbarService, validateLatLongFormat } from '@app/shared';
import { CustomerModuleApiSuffixModels } from '@modules/customer';
import { loggedInUserData } from '@modules/others';
import { OfficeAddressFormModel } from '@modules/others/configuration/models/office-address.model';
import { AddressModel, NewAddressPopupComponent, SalesModuleApiSuffixModels } from '@modules/sales';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { combineLatest, Observable, of } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
@Component({
  selector: 'app-office-address-add-edit',
  templateUrl: './office-address-add-edit.component.html',
  styles: [`
    ::ng-deep .fidelity-autocomplete-dropdown-con ng-component {
      position: absolute !important;
      bottom: -16px !important;
      left: 0px !important;
    }
  `]
})
export class OfficeAddressAddEditComponent implements OnInit {
  formConfigs = formConfigs;
  officeAddressDialogForm: FormGroup;
  isFormSubmitted = false;
  countryCodes = countryCodes;
  addressList = [];
  selectedAddressOption = {};
  isCustomAddressSaved = false;
  shouldShowLocationPinBtn = false;
  loggedInUserData: LoggedInUserModel;
  latLongObj;
  shouldShow = true;
  getLoopableObjectRequestObservable: Observable<IApplicationResponse>;
  @ViewChild("location", { static: false }) location: ElementRef<any>;

  constructor(private rxjsService: RxjsService, private dialog: MatDialog,
    public config: DynamicDialogConfig,
    private snackbarService: SnackbarService,
    public ref: DynamicDialogRef, private crudService: CrudService, private formBuilder: FormBuilder,
    private store: Store<AppState>) {
    this.rxjsService.setDialogOpenProperty(true);
  }

  ngOnInit() {
    this.combineLatestNgrxStoreDataOne();
    this.createOfficeAddressForm();
    this.onFormControlChanges();
  }

  combineLatestNgrxStoreDataOne() {
    combineLatest([
      this.store.select(loggedInUserData)]).subscribe((response) => {
        this.loggedInUserData = new LoggedInUserModel(response[0]);
        if (this.config?.data?.fidelityOfficeId) {
          this.getOfficeAddressDetailByFidelityOfficeId();
        }
      });
  }

  createOfficeAddressForm() {
    let leadInfoModel = new OfficeAddressFormModel();
    this.officeAddressDialogForm = this.formBuilder.group({});
    Object.keys(leadInfoModel).forEach((key) => {
      switch (key) {
        case "addressInfo":
          this.officeAddressDialogForm.addControl(key, this.createAndGetAddressForm());
          break;
        default:
          this.officeAddressDialogForm.addControl(key, new FormControl(leadInfoModel[key]));
          break;
      }
    });
    this.officeAddressDialogForm.get('phoneNoCountryCode').disable();
    this.officeAddressDialogForm = setRequiredValidator(this.officeAddressDialogForm, ["fidelityOfficeName", "phoneNo", "eMail"]);
    this.officeAddressDialogForm.controls["addressInfo"] = setRequiredValidator(
      this.officeAddressDialogForm.controls["addressInfo"] as FormGroup, ["formatedAddress", "latLong", "streetNo"]);
  }

  getOfficeAddressDetailByFidelityOfficeId() {
    this.rxjsService.setPopupLoaderProperty(true);
    this.crudService.get(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, CustomerModuleApiSuffixModels.OFFICE_ADDRESS, this.config?.data.fidelityOfficeId)
      .subscribe((response) => {
        if (response.isSuccess && response.statusCode === 200 && response.resources) {
          let officeAddressFormModel = new OfficeAddressFormModel(response.resources);
          this.selectedAddressOption["fullAddress"] = response.resources.addressInfo?.['fullAddress'];
          officeAddressFormModel.addressInfo.latLong = `${officeAddressFormModel.addressInfo.latitude}, ${officeAddressFormModel.addressInfo.longitude}`;
          this.officeAddressDialogForm.patchValue(officeAddressFormModel, { emitEvent: false, onlySelf: true });
        }
        this.rxjsService.setPopupLoaderProperty(false);
      });
  }

  get addressInfoFormGroupControls(): FormGroup {
    if (!this.officeAddressDialogForm) return;
    return this.officeAddressDialogForm.get("addressInfo") as FormGroup;
  }

  createAndGetAddressForm(address?: AddressModel): FormGroup {
    let addressModel = new AddressModel(address);
    let formControls = {};
    Object.keys(addressModel).forEach((key) => {
      if (key === "streetName" || key === "suburbName" ||
        key === "cityName" || key === "provinceName" || key === "postalCode" || key === "estateStreetNo" ||
        key === "estateStreetName" || key === "estateName" || key === "addressConfidentLevelName") {
        formControls[key] = new FormControl({
          value: addressModel[key],
          disabled: true,
        });
      } else {
        formControls[key] = new FormControl(addressModel[key]);
      }
    });
    return this.formBuilder.group(formControls);
  }


  onSelectedItemOption(selectedObject): void {
    if (!selectedObject) return;
    this.selectedAddressOption = selectedObject;
    if (this.addressInfoFormGroupControls.get('isAfrigisSearch').value) {
      this.officeAddressDialogForm.controls["addressInfo"].get("seoid").setValue(selectedObject["seoid"]);
      this.getAddressFullDetails(selectedObject["seoid"]);
      this.addressInfoFormGroupControls.get('addressId').setValue(this.addressInfoFormGroupControls.get('addressId').value ? this.addressInfoFormGroupControls.get('addressId').value : null);
    } else {
      selectedObject["longitude"] = selectedObject["longitude"] ? selectedObject["longitude"] : "";
      selectedObject["latitude"] = selectedObject["latitude"] ? selectedObject["latitude"] : "";
      if (selectedObject["latitude"] && selectedObject["longitude"]) {
        selectedObject["latLong"] = `${selectedObject["latitude"]}, ${selectedObject["longitude"]}`;
      } else {
        selectedObject["latLong"] = "";
      }
      this.addressInfoFormGroupControls.patchValue(
        {
          addressId: selectedObject['addressId'],
          seoid: "",
          jsonObject: "",
          latitude: selectedObject["latitude"],
          longitude: selectedObject["longitude"],
          latLong: selectedObject["latLong"],
          suburbName: selectedObject["suburbName"],
          cityName: selectedObject["cityName"],
          provinceName: selectedObject["provinceName"],
          postalCode: selectedObject["postalCode"],
          streetName: selectedObject["streetName"],
          streetNo: selectedObject["streetNo"],
          estateName: selectedObject["estateName"],
          estateStreetName: selectedObject["estateStreetName"],
          estateStreetNo: selectedObject["estateStreetNo"],
          buildingName: selectedObject["buildingName"],
          buildingNo: selectedObject["buildingNo"],
          addressConfidentLevelName: selectedObject["addressConfidentLevelName"],
          addressConfidentLevelId: selectedObject["addressConfidentLevelId"]
        }, { emitEvent: false, onlySelf: true });
      this.focusAndBlurLocationField();
      
      // Update form validation after patching values
      this.addressInfoFormGroupControls.updateValueAndValidity({ emitEvent: false, onlySelf: true });
    }
  }

  focusAndBlurLocationField() {
    if (this.location) {
      this.location.nativeElement.focus();
      this.location.nativeElement.blur();
    }
  }

  onFormControlChanges() {
    this.officeAddressDialogForm.get("phoneNo").valueChanges.subscribe((phoneNo: string) => {
      this.setPhoneNumberLengthByCountryCode(this.officeAddressDialogForm.get("phoneNoCountryCode").value);
    });
    this.addressInfoFormGroupControls.get('isAfrigisSearch').valueChanges.subscribe((isAfrigisSearch: boolean) => {
      this.addressInfoFormGroupControls.get('formatedAddress').setValue(this.addressInfoFormGroupControls.get('formatedAddress').value);
      if (isAfrigisSearch) {
        this.addressInfoFormGroupControls.get('addressId').setValue(this.addressInfoFormGroupControls.get('addressId').value ?
          this.addressInfoFormGroupControls.get('addressId').value : "");
        this.clearAddressFormGroupValues('afrigis search checkbox');
      }
    });
    this.addressInfoFormGroupControls.get('formatedAddress').valueChanges.subscribe((formatedAddress) => {
      // Clear any existing address confirmation flags if needed
    });
    this.onFormatedAddressFormControlValueChanges();
    this.addressInfoFormGroupControls.get("isAddressComplex").valueChanges.subscribe((isAddressComplex: boolean) => {
      if (!isAddressComplex) {
        this.addressInfoFormGroupControls.get("buildingNo").setValue(null);
        this.addressInfoFormGroupControls.get("buildingName").setValue(null);
      }
    });
    
    // Add value change listeners for building fields to remove "at least one of the fields" error
    this.addressInfoFormGroupControls.get('buildingNo').valueChanges.subscribe((buildingNo) => {
      if (buildingNo) {
        this.officeAddressDialogForm.controls["addressInfo"] = removeFormControlError(this.officeAddressDialogForm.controls["addressInfo"] as FormGroup, "atleastOneOfTheFieldsIsRequired", "buildingName");
      }
    });
    
    this.addressInfoFormGroupControls.get('buildingName').valueChanges.subscribe((buildingName) => {
      if (buildingName) {
        this.officeAddressDialogForm.controls["addressInfo"] = removeFormControlError(this.officeAddressDialogForm.controls["addressInfo"] as FormGroup, "atleastOneOfTheFieldsIsRequired", "buildingNo");
      }
    });
    this.addressInfoFormGroupControls.get("isAddressExtra").valueChanges.subscribe((isAddressExtra: boolean) => {
      if (isAddressExtra) {
        this.officeAddressDialogForm.controls["addressInfo"] = enableFormControls(this.officeAddressDialogForm.controls["addressInfo"] as FormGroup,
          ["estateStreetNo", "estateStreetName", "estateName"]);
      } else {
        this.officeAddressDialogForm.controls["addressInfo"] = disableFormControls(this.officeAddressDialogForm.controls["addressInfo"] as FormGroup,
          ["estateStreetNo", "estateStreetName", "estateName"]);
        this.addressInfoFormGroupControls.get("estateStreetNo").setValue(null);
        this.addressInfoFormGroupControls.get("estateStreetName").setValue(null);
        this.addressInfoFormGroupControls.get("estateName").setValue(null);
      }
    });
    
    // Add value change listeners for estate fields to remove "at least one of the fields" error
    this.addressInfoFormGroupControls.get('estateStreetNo').valueChanges.subscribe((estateStreetNo) => {
      if (estateStreetNo) {
        this.officeAddressDialogForm.controls["addressInfo"] = removeFormControlError(this.officeAddressDialogForm.controls["addressInfo"] as FormGroup, "atleastOneOfTheFieldsIsRequired", "estateStreetName");
        this.officeAddressDialogForm.controls["addressInfo"] = removeFormControlError(this.officeAddressDialogForm.controls["addressInfo"] as FormGroup, "atleastOneOfTheFieldsIsRequired", "estateName");
      }
    });
    
    this.addressInfoFormGroupControls.get('estateStreetName').valueChanges.subscribe((estateStreetName) => {
      if (estateStreetName) {
        this.officeAddressDialogForm.controls["addressInfo"] = removeFormControlError(this.officeAddressDialogForm.controls["addressInfo"] as FormGroup, "atleastOneOfTheFieldsIsRequired", "estateStreetNo");
        this.officeAddressDialogForm.controls["addressInfo"] = removeFormControlError(this.officeAddressDialogForm.controls["addressInfo"] as FormGroup, "atleastOneOfTheFieldsIsRequired", "estateName");
      }
    });
    
    this.addressInfoFormGroupControls.get('estateName').valueChanges.subscribe((estateName) => {
      if (estateName) {
        this.officeAddressDialogForm.controls["addressInfo"] = removeFormControlError(this.officeAddressDialogForm.controls["addressInfo"] as FormGroup, "atleastOneOfTheFieldsIsRequired", "estateStreetNo");
        this.officeAddressDialogForm.controls["addressInfo"] = removeFormControlError(this.officeAddressDialogForm.controls["addressInfo"] as FormGroup, "atleastOneOfTheFieldsIsRequired", "estateStreetName");
      }
    });
    
    // Add latitude/longitude validation on value change
    this.addressInfoFormGroupControls.get('latLong').valueChanges.subscribe((latLongValue) => {
      if (latLongValue) {
        if (!validateLatLongFormat(latLongValue)) {
          this.addressInfoFormGroupControls.get('latLong').setErrors({ 'invalid': true });
        } else {
          // Clear invalid error if format is valid
          const currentErrors = this.addressInfoFormGroupControls.get('latLong').errors;
          if (currentErrors && currentErrors['invalid']) {
            delete currentErrors['invalid'];
            this.addressInfoFormGroupControls.get('latLong').setErrors(Object.keys(currentErrors).length ? currentErrors : null);
          }
        }
      }
    });
  }

  onFormatedAddressFormControlValueChanges(): void {
    this.addressInfoFormGroupControls
      .get("formatedAddress")
      .valueChanges.pipe(
        debounceTime(debounceTimeForSearchkeyword)).subscribe((searchtext) => {
          if (searchtext == "") {
            this.clearAddressFormGroupValues();
          }
          if (!searchtext || this.isCustomAddressSaved == true) {
            this.getLoopableObjectRequestObservable = of();
          }
          else {
            this.getLoopableObjectRequestObservable = this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_UX_ADDRESS, null, true,
              prepareRequiredHttpParams({
                searchtext,
                isAfrigisSearch: this.addressInfoFormGroupControls.get("isAfrigisSearch").value
              }));
          }
        });
  }

  clearAddressFormGroupValues(fromType = 'template'): void {
    this.addressInfoFormGroupControls.patchValue({
      latitude: null,
      longitude: null,
      latLong: null,
      suburbName: null,
      cityName: null,
      provinceName: null,
      postalCode: null,
      streetName: null,
      streetNo: null,
      buildingNo: null,
      buildingName: null,
      estateName: null,
      estateStreetName: null,
      estateStreetNo: null,
    });
    if (fromType == 'template') {
      this.focusAndBlurLocationField();
    }
  }

  getAddressFullDetails(seoid: string) {
    this.rxjsService.setPopupLoaderProperty(true);
    this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_ADDRESS_DETAILS, undefined, false,
      prepareRequiredHttpParams({ seoid })).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200 && response.resources) {
          this.officeAddressDialogForm.controls["addressInfo"].get("jsonObject").setValue(JSON.stringify(response.resources));
          this.addressInfoFormGroupControls.get("addressConfidentLevelName").setValue(response.resources.addressConfidenceLevel);
          response.resources.addressDetails.forEach((addressObj) => {
            this.addressInfoFormGroupControls.get("addressConfidentLevelId").setValue(addressObj.confidence);
            this.patchAddressFormGroupValues(addressObj, addressObj["address_components"]);
          });
          this.addressInfoFormGroupControls.updateValueAndValidity();
        }
        this.focusAndBlurLocationField();
        this.rxjsService.setPopupLoaderProperty(false);
      });
  }

  patchAddressFormGroupValues(addressObj, addressComponents: Object[]) {
    addressObj.geometry.location.lat = addressObj.geometry.location.lat
      ? addressObj.geometry.location.lat : "";
    addressObj.geometry.location.lng = addressObj.geometry.location.lng
      ? addressObj.geometry.location.lng : "";
    if (addressObj.geometry.location.lat && addressObj.geometry.location.lng) {
      addressObj.geometry.location.latLong = `${addressObj.geometry.location.lat}, ${addressObj.geometry.location.lng}`;
    } else {
      addressObj.geometry.location.latLong = "";
    }
    let { suburbName, cityName, provinceName, postalCode, streetName, streetNo, buildingNo,
      buildingName, estateName, estateStreetName, estateStreetNo } = destructureAfrigisObjectAddressComponents(addressComponents);
    this.addressInfoFormGroupControls.patchValue({
      latitude: addressObj.geometry.location.lat,
      longitude: addressObj.geometry.location.lng,
      latLong: addressObj.geometry.location.latLong,
      buildingName, buildingNo, estateName, estateStreetName,
      estateStreetNo, suburbName, cityName, provinceName, postalCode, streetName, streetNo,
    },
      { emitEvent: false, onlySelf: true });
    
    // Update form validation after patching values
    this.addressInfoFormGroupControls.updateValueAndValidity({ emitEvent: false, onlySelf: true });
  }

  setPhoneNumberLengthByCountryCode(countryCode: string) {
    switch (countryCode) {
      case "+27":
        this.officeAddressDialogForm.get("phoneNo").setValidators([
          Validators.minLength(formConfigs.southAfricanContactNumberMaxLength),
          Validators.maxLength(formConfigs.southAfricanContactNumberMaxLength)]);
        break;
      default:
        this.officeAddressDialogForm.get("phoneNo").setValidators([
          Validators.minLength(formConfigs.indianContactNumberMaxLength),
          Validators.maxLength(formConfigs.indianContactNumberMaxLength)]);
        break;
    }
  }

  btnCloseClick() {
    this.ref.close(false);
    this.rxjsService.setPopupLoaderProperty(false);
  }

  openFullMapViewWithConfig() {
    mapConfigurationUtils(this.rxjsService, this.dialog, 'Two Table Architecture Custom Address', this.latLongObj)
      .afterClosed().subscribe((result) => {
        if (result?.hasOwnProperty('latLong')) {
          this.latLongObj = result.latLong;
          this.addressInfoFormGroupControls
            .get("latLong").setValue(`${result.latLong.lat}, ${result.latLong.lng}`)
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  openAddressPopup(): void {
    this.officeAddressDialogForm.value.header = this.config?.data?.header;
    this.officeAddressDialogForm.value.createdUserId = this.loggedInUserData.userId;
    this.officeAddressDialogForm.value.modifiedUserId = this.loggedInUserData.userId;
    this.officeAddressDialogForm.value.fromComponent = 'Office Address';
    let officeAddressDialogForm = { ...this.officeAddressDialogForm.value, ...this.officeAddressDialogForm.getRawValue() };
    this.shouldShow = false;
    const dialogReff = this.dialog.open(NewAddressPopupComponent, {
      width: "650px", disableClose: true, data: officeAddressDialogForm
    });
    dialogReff.afterClosed().subscribe((result) => {
      this.rxjsService.setDialogOpenProperty(true);
      this.shouldShow = true;
      if (result) {
        this.isCustomAddressSaved = false;
      }
    });
    dialogReff.componentInstance.outputData.subscribe((result) => {
      this.shouldShow = true;
      this.rxjsService.setDialogOpenProperty(true);
      if (result) {
        this.rxjsService.setFormChangeDetectionProperty(true);
        this.isCustomAddressSaved = true;
        this.shouldShowLocationPinBtn = true;
        this.addressInfoFormGroupControls.patchValue({
          formatedAddress: getFullFormatedAddress(result),
          addressConfidentLevelId: result.addressConfidentLevelId,
          suburbName: result.suburbName,
          cityName: result.cityName,
          provinceName: result.provinceName,
          postalCode: result.postalCode,
          streetName: result.streetName,
          streetNo: result.streetNo,
          buildingNo: result.buildingNo,
          buildingName: result.buildingName,
          estateName: result.estateName,
          estateStreetName: result.estateStreetName,
          estateStreetNo: result.estateStreetNo,
        });
      }
      else {
        this.isCustomAddressSaved = false;
      }
    });
  }

  setAtleastOneFieldRequiredError() {
    if (this.addressInfoFormGroupControls.get("isAddressComplex").value) {
      this.addressInfoFormGroupControls.get("buildingNo").setErrors({ atleastOneOfTheFieldsIsRequired: true });
      this.addressInfoFormGroupControls.get("buildingName").setErrors({ atleastOneOfTheFieldsIsRequired: true });
    }
    if (this.addressInfoFormGroupControls.get("isAddressExtra").value) {
      this.addressInfoFormGroupControls.get("estateName").setErrors({ atleastOneOfTheFieldsIsRequired: true });
      this.addressInfoFormGroupControls.get("estateStreetNo").setErrors({ atleastOneOfTheFieldsIsRequired: true });
      this.addressInfoFormGroupControls.get("estateStreetName").setErrors({ atleastOneOfTheFieldsIsRequired: true });
    }
  }

  validateAtleastOneFieldToBeMandatory(type: string): void {
    if (type === "addressInfo") {
      if (
        (this.addressInfoFormGroupControls.get("isAddressComplex").value && !this.addressInfoFormGroupControls.get("buildingNo").value &&
          !this.addressInfoFormGroupControls.get("buildingName").value) ||
        (
          this.addressInfoFormGroupControls.get("isAddressExtra").value &&
          !this.addressInfoFormGroupControls.get("estateName").value && !this.addressInfoFormGroupControls.get("estateStreetName").value &&
          !this.addressInfoFormGroupControls.get("estateStreetNo").value
        )
      ) {
        this.setAtleastOneFieldRequiredError();
      }
      else {
        this.officeAddressDialogForm.controls["addressInfo"] = removeFormControlError(this.officeAddressDialogForm.controls["addressInfo"] as FormGroup,
          "atleastOneOfTheFieldsIsRequired");
      }
    }
  }

  onSubmit() {
    this.isFormSubmitted = true;
    
    // Validate "at least one of the fields" requirements first
    this.validateAtleastOneFieldToBeMandatory("addressInfo");
    
    // Update form validation state to reflect current field values
    this.officeAddressDialogForm.updateValueAndValidity({ emitEvent: false, onlySelf: true });
    
    if (this.officeAddressDialogForm.invalid) {
      return this.officeAddressDialogForm.markAllAsTouched();
    }
    if ((this.addressInfoFormGroupControls.get("isAddressComplex").value && !this.addressInfoFormGroupControls.get("buildingNo").value &&
      !this.addressInfoFormGroupControls.get("buildingName").value) || (this.addressInfoFormGroupControls.get("isAddressExtra").value &&
        !this.addressInfoFormGroupControls.get("estateName").value && !this.addressInfoFormGroupControls.get("estateStreetName").value &&
        !this.addressInfoFormGroupControls.get("estateStreetNo").value)) {
      this.setAtleastOneFieldRequiredError();
      return this.officeAddressDialogForm.markAllAsTouched();
    }
    else {
      this.officeAddressDialogForm.controls["addressInfo"] = removeFormControlError(this.officeAddressDialogForm.controls["addressInfo"] as FormGroup,
        "atleastOneOfTheFieldsIsRequired");
    }
    if (this.addressInfoFormGroupControls.get('latLong').value) {
      this.addressInfoFormGroupControls.get('latitude').setValue(this.addressInfoFormGroupControls.value.latLong.split(",")[0]);
      this.addressInfoFormGroupControls.get('longitude').setValue(this.addressInfoFormGroupControls.value.latLong.split(",")[1]);
    }
    let addressFormGroupRawValues = this.addressInfoFormGroupControls.getRawValue();
    if (!addressFormGroupRawValues.provinceName || !addressFormGroupRawValues.suburbName || !addressFormGroupRawValues.cityName) {
      this.snackbarService.openSnackbar("Province Name / Suburb Name / City Name is required..!!", ResponseMessageTypes.ERROR);
      return;
    }
    
    // Validate latitude/longitude format
    const latLongValue = this.addressInfoFormGroupControls.get('latLong').value;
    if (latLongValue && !validateLatLongFormat(latLongValue)) {
      this.addressInfoFormGroupControls.get('latLong').setErrors({ 'invalid': true });
      this.snackbarService.openSnackbar("Invalid latitude/longitude format. Please use format: latitude, longitude", ResponseMessageTypes.ERROR);
      return;
    }
    this.officeAddressDialogForm.value.phoneNo = this.officeAddressDialogForm.value.phoneNo.toString().replace(/\s/g, "");
    const payload = this.officeAddressDialogForm.getRawValue();
    payload.addressInfo = addressFormGroupRawValues;
    if (this.config?.data?.fidelityOfficeId) {
      payload['modifiedUserId'] = this.loggedInUserData.userId;
    }
    else {
      payload['createdUserId'] = this.loggedInUserData.userId;
    }
    if (typeof payload.phoneNo === "string") {
      payload.phoneNo = payload.phoneNo.split(" ").join("");
      payload.phoneNo = payload.phoneNo.replace(/"/g, "");
    }
    let crudService: Observable<IApplicationResponse> = this.crudService.create(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, CustomerModuleApiSuffixModels.OFFICE_ADDRESS, payload)
    if (this.officeAddressDialogForm.value?.fidelityOfficeId) {
      crudService = this.crudService.update(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, CustomerModuleApiSuffixModels.OFFICE_ADDRESS, payload);
    }
    this.rxjsService.setPopupLoaderProperty(true);
    crudService.subscribe((response) => {
      if (response.isSuccess == true && response.statusCode == 200) {
        this.ref.close(response);
      }
      this.rxjsService.setPopupLoaderProperty(false);
    });
  }
}
